import { render, staticRenderFns } from "./StickyNoteBoard.vue?vue&type=template&id=6b2b8248&scoped=true&"
import script from "./StickyNoteBoard.vue?vue&type=script&lang=js&"
export * from "./StickyNoteBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b8248",
  null
  
)

export default component.exports